var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"philosophy"},[_c('div',{staticClass:"site-margins"},[_c('h1',[_vm._v("Philosophy")]),_c('div',{staticClass:"philosophy"},[_c('div',{staticClass:"main-img"},[(
            _vm.philosophy.mainImage.type &&
            _vm.philosophy.mainImage.type.includes('image')
          )?_c('img',{attrs:{"src":_vm.philosophy.mainImage.url}}):(
            _vm.philosophy.mainImage.type &&
            _vm.philosophy.mainImage.type.includes('video')
          )?_c('video',{attrs:{"src":_vm.philosophy.mainImage.url,"controls":""}}):_vm._e()]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.philosophy.description)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }